// Deccos's own legal documents — the Algemene voorwaarden and privacybeleid a
// new customer must accept during onboarding (Step 1).
//
// Versions are tracked PER DOCUMENT (they change independently — see the live
// docs). The consent record stores these version strings, not the URLs, so the
// URLs can move to deccos.nl later with zero data migration. When a document
// changes materially, bump its version here AND archive a PDF snapshot of the
// version that was accepted (see docs/features/onboarding-terms-consent.md).
//
// Mirrored by functions/legalDocs.js. This file is the SOURCE; the *_VERSION
// values are pinned across both trees by functions/legalDocs.test.js, which
// reads this file and fails on any difference. Bump a version here and that
// test goes red until the mirror follows — deliberate, because the consent
// record stores the version STRING: a one-sided bump would record acceptance
// of a version nobody was shown.
// AI-CONTEXT: See docs/pitfalls.md#dev-mirrored-constant-guarded-only-by-a-comment

// Temporary hosting: company Google Docs, "anyone with the link → Viewer".
// /preview = clean read-only view (no editor chrome, no "request access" wall).
export const TERMS_URL =
    'https://docs.google.com/document/d/1FV4YgmF3E2Z_OA-YFs7cJaLjQLXxcfVu/preview'
export const PRIVACY_URL =
    'https://docs.google.com/document/d/1xhFBH4gSrCdu2s2OVwtnRcozhtuANN8k/preview'

export const TERMS_VERSION = '2026-06'
export const PRIVACY_VERSION = '2026-06'
